import { TransactionCategory } from "../../../../model/transaction";

export interface TransactionFilters {
  category: number | null;
  status: number | null;
  period: string | null;
  startDate: Date | null;
  endDate: Date | null;
}

export const DEFAULT_FILTERS: TransactionFilters = {
  category: null,
  status: null,
  period: null,
  startDate: null,
  endDate: null,
};

export const CATEGORY_OPTIONS = [
  { label: "All Category", value: null },
  { label: "Vending Transactions", value: TransactionCategory.VendingTransaction },
  { label: "Billing Transactions", value: TransactionCategory.BillingTransaction },
  { label: "Order Transactions", value: TransactionCategory.OrderTransactions },
  { label: "Installment Transactions", value: TransactionCategory.InstallmentTransaction },
  { label: "Pay As You Go Transactions", value: TransactionCategory.PayAsYouGoTransaction },
  { label: "Bulk Purchase", value: TransactionCategory.BulkPurchaseTransaction },
  { label: "Service Request", value: TransactionCategory.ServiceRequesTransaction },
] as const;

export const STATUS_OPTIONS = [
  { label: "All Status", value: null },
  { label: "Success", value: 2 },
  { label: "Pending", value: 1 },
  { label: "Failed", value: 3 },
  { label: "Reversed", value: 4 },
] as const;

let pendingFilters: TransactionFilters | null = null;
export const setPendingFilters = (f: TransactionFilters) => { pendingFilters = f; };
export const consumePendingFilters = (): TransactionFilters | null => {
  const f = pendingFilters;
  pendingFilters = null;
  return f;
};

export const PERIOD_OPTIONS = [
  { label: "Custom", value: null },
  { label: "Current Week", value: "currentWeek" },
  { label: "Last Week", value: "lastWeek" },
  { label: "Current Month", value: "currentMonth" },
  { label: "Last Month", value: "lastMonth" },
  { label: "Current Year", value: "currentYear" },
  { label: "Last Year", value: "lastYear" },
] as const;
